import React, { useCallback, useState } from "react";
import { Box, TextField, Button, Typography, useTheme, Divider } from "@mui/material";
import { CheckCircleOutlineOutlined, HighlightOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const AccountView = () => {
  const containerStyle = {
    display: "flex",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "space-between",
    px: 16,
  };

  return <Box sx={containerStyle}>Accounts</Box>;
};

export default AccountView;
